/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API For public part of application: Inzerce movitého majetku
 * This API provides endpoints for public part: Inzerce movitého majetku
 * OpenAPI spec version: v1
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";

import type {
	ClientError,
	FileItemDto,
	GalleryItemDto,
	ProblemDetails,
} from "../aPIForPublicPartOfApplicationInzerceMovitéhoMajetku.schemas";

import { restAxiosFetcher } from "../../restAxiosFetcher";
import type { ErrorType } from "../../restAxiosFetcher";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieves the gallery images associated with a specific asset advertisement.
 */
export const getApiAssetsmultimediaAdvertisementIdGallery = (
	advertisementId: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<GalleryItemDto[]>(
		{ url: `/api/assetsmultimedia/${encodeURIComponent(String(advertisementId))}/gallery`, method: "GET", signal },
		options,
	);
};

export const getGetApiAssetsmultimediaAdvertisementIdGalleryQueryKey = (advertisementId: number) => {
	return [`/api/assetsmultimedia/${advertisementId}/gallery`] as const;
};

export const getGetApiAssetsmultimediaAdvertisementIdGalleryQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaAdvertisementIdGalleryQueryKey(advertisementId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>> = ({
		signal,
	}) => getApiAssetsmultimediaAdvertisementIdGallery(advertisementId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!advertisementId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAdvertisementIdGalleryQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>
>;
export type GetApiAssetsmultimediaAdvertisementIdGalleryQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaAdvertisementIdGallery<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdGallery<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdGallery<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the gallery images associated with a specific asset advertisement.
 */

export function useGetApiAssetsmultimediaAdvertisementIdGallery<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdGalleryQueryOptions(advertisementId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves the gallery images associated with a specific asset advertisement.
 */
export const prefetchGetApiAssetsmultimediaAdvertisementIdGalleryQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdGalleryQueryOptions(advertisementId, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsmultimediaAdvertisementIdGallerySuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaAdvertisementIdGalleryQueryKey(advertisementId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>> = ({
		signal,
	}) => getApiAssetsmultimediaAdvertisementIdGallery(advertisementId, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAdvertisementIdGallerySuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>
>;
export type GetApiAssetsmultimediaAdvertisementIdGallerySuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaAdvertisementIdGallerySuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdGallerySuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdGallerySuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the gallery images associated with a specific asset advertisement.
 */

export function useGetApiAssetsmultimediaAdvertisementIdGallerySuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdGallery>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdGallerySuspenseQueryOptions(advertisementId, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves all attachments associated with a specific asset advertisement.
 */
export const getApiAssetsmultimediaAdvertisementIdAttachments = (
	advertisementId: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<FileItemDto[]>(
		{ url: `/api/assetsmultimedia/${encodeURIComponent(String(advertisementId))}/attachments`, method: "GET", signal },
		options,
	);
};

export const getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryKey = (advertisementId: number) => {
	return [`/api/assetsmultimedia/${advertisementId}/attachments`] as const;
};

export const getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryKey(advertisementId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>> = ({
		signal,
	}) => getApiAssetsmultimediaAdvertisementIdAttachments(advertisementId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!advertisementId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAdvertisementIdAttachmentsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>
>;
export type GetApiAssetsmultimediaAdvertisementIdAttachmentsQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaAdvertisementIdAttachments<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdAttachments<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdAttachments<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves all attachments associated with a specific asset advertisement.
 */

export function useGetApiAssetsmultimediaAdvertisementIdAttachments<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryOptions(advertisementId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves all attachments associated with a specific asset advertisement.
 */
export const prefetchGetApiAssetsmultimediaAdvertisementIdAttachmentsQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	advertisementId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryOptions(advertisementId, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetApiAssetsmultimediaAdvertisementIdAttachmentsQueryKey(advertisementId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>> = ({
		signal,
	}) => getApiAssetsmultimediaAdvertisementIdAttachments(advertisementId, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAdvertisementIdAttachmentsSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>
>;
export type GetApiAssetsmultimediaAdvertisementIdAttachmentsSuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves all attachments associated with a specific asset advertisement.
 */

export function useGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
	TError = ErrorType<ClientError>,
>(
	advertisementId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getApiAssetsmultimediaAdvertisementIdAttachments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAdvertisementIdAttachmentsSuspenseQueryOptions(
		advertisementId,
		options,
	);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves an image file by its identifier.
 */
export const getApiAssetsmultimediaImageId = (
	id: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<Blob>(
		{
			url: `/api/assetsmultimedia/image/${encodeURIComponent(String(id))}`,
			method: "GET",
			responseType: "blob",
			signal,
		},
		options,
	);
};

export const getGetApiAssetsmultimediaImageIdQueryKey = (id: number) => {
	return [`/api/assetsmultimedia/image/${id}`] as const;
};

export const getGetApiAssetsmultimediaImageIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaImageIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>> = ({ signal }) =>
		getApiAssetsmultimediaImageId(id, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaImageIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>
>;
export type GetApiAssetsmultimediaImageIdQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaImageId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaImageId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaImageId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves an image file by its identifier.
 */

export function useGetApiAssetsmultimediaImageId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaImageIdQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves an image file by its identifier.
 */
export const prefetchGetApiAssetsmultimediaImageIdQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsmultimediaImageIdQueryOptions(id, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsmultimediaImageIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaImageIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>> = ({ signal }) =>
		getApiAssetsmultimediaImageId(id, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaImageIdSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>
>;
export type GetApiAssetsmultimediaImageIdSuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaImageIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaImageIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaImageIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves an image file by its identifier.
 */

export function useGetApiAssetsmultimediaImageIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaImageId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaImageIdSuspenseQueryOptions(id, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves the thumbnail image for a specific asset advertisement in the iframe view.
 */
export const getApiAssetsmultimediaThumbnailId = (
	id: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<Blob>(
		{
			url: `/api/assetsmultimedia/thumbnail/${encodeURIComponent(String(id))}`,
			method: "GET",
			responseType: "blob",
			signal,
		},
		options,
	);
};

export const getGetApiAssetsmultimediaThumbnailIdQueryKey = (id: number) => {
	return [`/api/assetsmultimedia/thumbnail/${id}`] as const;
};

export const getGetApiAssetsmultimediaThumbnailIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaThumbnailIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>> = ({ signal }) =>
		getApiAssetsmultimediaThumbnailId(id, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaThumbnailIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>
>;
export type GetApiAssetsmultimediaThumbnailIdQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaThumbnailId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaThumbnailId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaThumbnailId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the thumbnail image for a specific asset advertisement in the iframe view.
 */

export function useGetApiAssetsmultimediaThumbnailId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaThumbnailIdQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves the thumbnail image for a specific asset advertisement in the iframe view.
 */
export const prefetchGetApiAssetsmultimediaThumbnailIdQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	queryClient: QueryClient,
	id: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsmultimediaThumbnailIdQueryOptions(id, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsmultimediaThumbnailIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaThumbnailIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>> = ({ signal }) =>
		getApiAssetsmultimediaThumbnailId(id, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaThumbnailIdSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>
>;
export type GetApiAssetsmultimediaThumbnailIdSuspenseQueryError = ErrorType<ClientError>;

export function useGetApiAssetsmultimediaThumbnailIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaThumbnailIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaThumbnailIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the thumbnail image for a specific asset advertisement in the iframe view.
 */

export function useGetApiAssetsmultimediaThumbnailIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>,
	TError = ErrorType<ClientError>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaThumbnailId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaThumbnailIdSuspenseQueryOptions(id, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a multimedia file by its identifier.
 */
export const getApiAssetsmultimediaAttachmentMultimediaId = (
	multimediaId: number,
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<Blob>(
		{
			url: `/api/assetsmultimedia/attachment/${encodeURIComponent(String(multimediaId))}`,
			method: "GET",
			responseType: "blob",
			signal,
		},
		options,
	);
};

export const getGetApiAssetsmultimediaAttachmentMultimediaIdQueryKey = (multimediaId: number) => {
	return [`/api/assetsmultimedia/attachment/${multimediaId}`] as const;
};

export const getGetApiAssetsmultimediaAttachmentMultimediaIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaAttachmentMultimediaIdQueryKey(multimediaId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>> = ({
		signal,
	}) => getApiAssetsmultimediaAttachmentMultimediaId(multimediaId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!multimediaId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAttachmentMultimediaIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>
>;
export type GetApiAssetsmultimediaAttachmentMultimediaIdQueryError = ErrorType<ProblemDetails>;

export function useGetApiAssetsmultimediaAttachmentMultimediaId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAttachmentMultimediaId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAttachmentMultimediaId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a multimedia file by its identifier.
 */

export function useGetApiAssetsmultimediaAttachmentMultimediaId<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAttachmentMultimediaIdQueryOptions(multimediaId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a multimedia file by its identifier.
 */
export const prefetchGetApiAssetsmultimediaAttachmentMultimediaIdQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	queryClient: QueryClient,
	multimediaId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetsmultimediaAttachmentMultimediaIdQueryOptions(multimediaId, options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetsmultimediaAttachmentMultimediaIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetsmultimediaAttachmentMultimediaIdQueryKey(multimediaId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>> = ({
		signal,
	}) => getApiAssetsmultimediaAttachmentMultimediaId(multimediaId, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetsmultimediaAttachmentMultimediaIdSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>
>;
export type GetApiAssetsmultimediaAttachmentMultimediaIdSuspenseQueryError = ErrorType<ProblemDetails>;

export function useGetApiAssetsmultimediaAttachmentMultimediaIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAttachmentMultimediaIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetsmultimediaAttachmentMultimediaIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a multimedia file by its identifier.
 */

export function useGetApiAssetsmultimediaAttachmentMultimediaIdSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>,
	TError = ErrorType<ProblemDetails>,
>(
	multimediaId: number,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetsmultimediaAttachmentMultimediaId>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetsmultimediaAttachmentMultimediaIdSuspenseQueryOptions(multimediaId, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}
